export const tickerDefaultConfig = {
    //font: "34px 'SairaCondensed-Bold'", //no retina values
    font: "68px 'SairaCondensed-Bold'",
    pxPerSymbol: 15,
    //pxPerSymbol: 30,
    //height: 34,
    height: 68,
    fillStyle: "#f9cc1e",
    textAlign: "left",
    textBaseline: "middle",
    shadowOffsetX: 0,
    shadowOffsetY: 2,
    shadowBlur: 10,
    shadowColor: "rgba(236, 249, 30, 0.4)"
};
export const tickerPopupDesktopConfigOverrides = {
    //font: "54px 'SairaCondensed-Bold'",
    font: "108px 'SairaCondensed-Bold'",
    pxPerSymbol: 23,
    //pxPerSymbol: 46,
    //height: 54,
    height: 108
};
export const tickerPopupMobileConfigOverrides = {
    //font: "44px 'SairaCondensed-Bold'",
    font: "88px 'SairaCondensed-Bold'",
    pxPerSymbol: 19,
    //pxPerSymbol: 38,
    //height: 44,
    height: 88
};
//# sourceMappingURL=TickerDefaultConfig.js.map